import { useState } from 'react';
const useCustomHook = () => {
  const [targetRequest, setTargetRequest] = useState(null);
  const [docTypes, setDocTypes] = useState([]);
  const [docTypesLoading, setdocTypesLoading] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disableDelete, setDisableDelete] = useState(true);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  return {
    targetRequest,
    setTargetRequest,
    docTypes,
    setDocTypes,
    docTypesLoading,
    setdocTypesLoading,
    canceling,
    setCanceling,
    loading,
    setLoading,
    disableDelete,
    setDisableDelete,
    isConfirmOpen,
    setIsConfirmOpen,
  };
};

export default useCustomHook;
